export enum Roles {
    UNKNOWN = 'UNKNOWN',
    ADMIN = 'ADMIN',
    ANNOTATOR = 'ANNOTATOR',
    REVIEWER = 'REVIEWER',
}


export interface MenuItems {
    label: string;
    icon: string; // material icons
    path: string;
    roles: Roles[];
    children?: MenuItems[];
    expanded?: boolean;
}

export const allRoles: Roles[] = [Roles.ADMIN, Roles.ANNOTATOR, Roles.REVIEWER];


export const menuItems: MenuItems[] = [
    {
        label: 'dashboard',
        icon: 'dashboard',
        path: 'dashboard',
        roles: [Roles.ADMIN],
    },
    {
        label: 'Status Dashboard',
        icon: 'query_stats',
        path: 'status-dashboard',
        roles: [Roles.ADMIN],
    },

    {
        label: 'Report Summary',
        icon: 'insert_chart',
        path: 'reports/summary',
        roles: [Roles.ANNOTATOR, Roles.REVIEWER],
    },

    {
        label: 'All Reports',
        icon: 'check_circle',
        path: 'reports/all-reports',
        roles: [Roles.ANNOTATOR, Roles.ADMIN, Roles.REVIEWER],
    },
    // ]
    // },
    {
        label: 'Configuration',
        icon: 'settings',
        path: 'configuration',
        roles: [Roles.ADMIN],
        children: [
            {
                label: 'System Users',
                icon: 'supervisor_account',
                path: 'system-users',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Case Assignment',
                icon: 'assignment_ind',
                path: 'case-assignment',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Reports Queue',
                icon: 'queue',
                path: 'reports-queue',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Test Master Data',
                icon: 'science',
                path: 'test-master-data',
                roles: [Roles.ADMIN],
            },
            {
                label: 'Settings',
                icon: 'tune',
                path: 'settings',
                roles: [Roles.ADMIN],
            },
            {
                label: 'License',
                icon: 'verified_user',
                path: 'license',
                roles: [Roles.ADMIN],
            }
        ]
    },



]